// How the back office waits for a contract draft generated in the background
// (CWA-187). Quick checks while a draft is most likely to land (most take
// 30–60 s), slower ones after that, and a cap matching the server's 15-minute
// window after which a stuck request may be replaced by a new one.
// Mutable so tests can shrink the waits.
export const contractDraftPolling = {
  fastIntervalMs: 3_000,
  fastPhaseMs: 2 * 60_000,
  slowIntervalMs: 10_000,
  maxWaitMs: 15 * 60_000,
};
